import React, { useState, useEffect,useRef, useMemo } from 'react';
import {Main,Axios,Loading,uuidv4,usePaginacion,Paginacion} from '../Helpers/importacionesComunes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt } from '@fortawesome/free-regular-svg-icons';
import { faFilePdf,faWindowClose,faFileExcel,faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import {useContextoGlobal} from '../Context/contextoGlobal';
import DatePicker from "react-datepicker";
import BusquedaSinForm from '../componentes/BusquedaSinForm';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import {formatearComparacion,formatoMoneda,hacerfocoEnPrimerInput,seleccionarTextoInput} from '../Helpers/utilidades-globales';
import {transformarIso8601,obtenerFechaDiamenosN,obtenerFechaUltimoDiaMes} from '../Helpers/fechas';
import ReportesEgresosIntegrados from '../reportes/ReportesEgresosIntegrados';
import {imprimir as imprimirEcronologicos} from '../impresiones/ecronologicos';
//import ReactExport from "react-export-excel";
import ImpresionPDF from '../componentes/ImpresionPDF';
import { Button, Card, Checkbox, Input, Option, Select, Spinner, Typography } from '@material-tailwind/react';

/*const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;*/

const anchoPaginacion = 50;


export default function ReportesEgIntegrales(){
    const [cargandoRegistros,setCargandoRegistros] = useState(false);
    const [huboError,setHuboError] = useState(false);
    const [datos,setDatos] = useState([]);
    const [registrosAmostrar,setRegistrosAmostrar] = useState([]);
    const [textoBusqueda,setTextoBusqueda] = useState('');
    const {usuario} = useContextoGlobal();
    const [contadorConsulta,setContadorConsulta]=useState(0);
    /*const [parametros,setParametros]=useState({id_region:usuario.id_region,
        id_rango:'-1',
        cant_meses_desde:-1,
        cant_meses_hasta:-1,
        promedio_desde:-1,
        promedio_hasta:-1,
        total_desde:-1,
        total_hasta:-1,
        mesesSi:false,
        promedioSi:false,
        aportesSi:false,
        fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
        fechaHasta:new Date()})*/    
    const [parametros,setParametros]=useState({id_tanda:103,
                                                id_año_fiscal:10,
                                                mesAño:new Date(),
                                                año:new Date(),
                                                tipo:'cronologico',
                                                criterio:'tanda',
                                                destino:null,
                                                nombre_destino:'',
                                                id_obrero:null,
                                                id_iglesia:null,
                                                id_proveedor:null,                                                
                                                formapago:null,
                                                rubro:null,
                                                fondo:null,
                                                moneda:1,
                                                caja:null,
                                                fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
                                                fechaHasta:new Date(),
                                                fecha:new Date(),
                                                descripcionCriterio:'',
                                                total_caja:false,
                                                total_diario:false,
                                                total_mensual:false,
                                                total_año:false,
                                                no_agrupar:false})
    const [periodosFiscales,setPeriodosFiscales] = useState([]);
    const [tandas,setTandas] = useState([]);
    const [rubros,setRubros] = useState([]);
    const [monedas,setMonedas] = useState([]);
    const [cajas,setCajas] = useState([]);
    const [fondos,setFondos] = useState([]);
    const [formasPago,setFormasPago] = useState([]);
    const [reporteEnEjecucion,setReporteEnEjecucion] = useState(false)
    const meses = [0,1,2,3,4,5,6,7,8,9,10,11,12];
    const {configuracion,paginar,inicializar} = usePaginacion();
    registerLocale('es', es)


    const subtitulo = useRef('');

    useEffect(()=>{
        buscarTablasGenerales()
        .then(()=>{
         console.log(tandas)
            // setParametros({...parametros,id_tanda:tandas[0].id_tanda})
        })
    },[])

    useEffect(()=>{
        setReporteEnEjecucion(false)
    },[parametros])

    useEffect(()=>{
        if(tandas.length>0){
            setParametros({...parametros,id_tanda:tandas[0].id_tanda})
        }
    },[tandas])

    useEffect(()=>{
        if(periodosFiscales.length>0){
            setParametros({...parametros,id_año_fiscal:periodosFiscales[0].id_año_fiscal})
        }
    },[periodosFiscales])
    
    useEffect(()=>{
        if(!parametros.destino){
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_iglesia:null,id_proveedor:null})
        }else if(parametros.destino=='pastor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }else if(parametros.destino=='proveedor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_obrero:null})
            hacerfocoEnPrimerInput('destino-n')
        }else{
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }
    },[parametros.destino])

    useEffect(()=>{
        subtitulo.current = crearSubtitulosSegunParametros()
    },[parametros,cargandoRegistros]) // agrego a las dependencias la variable cargandoRegistros para que cree el subtitulo inmediatamente aunque no hayan cambiado los parametros porque podría ejecutar el reporte sin modificar la selección o sea con los valores iniciales

      const buscarTablasGenerales = async ()=>{
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/reportes/tandas'),
            Axios.get('/api/tablasgenerales/reportes/perfiscales'),
            Axios.get('/api/reportes/tablas/rubros'),
            Axios.get('/api/reportes/tablas/monedas'),
            Axios.get('/api/reportes/tablas/cajas'),
            Axios.get('/api/reportes/tablas/fondos'),
            Axios.get('/api/reportes/tablas/formaspago')])
            setTandas(vectorResultados[0].data)
            setPeriodosFiscales(vectorResultados[1].data.reverse())
            setRubros(vectorResultados[2].data)
            setMonedas(vectorResultados[3].data)
            setCajas(vectorResultados[4].data)
            setFondos(vectorResultados[5].data)
            setFormasPago(vectorResultados[6].data.filter(f => f && (f.id_forma_pago != null || f.nombre)));
            
            setCargandoRegistros(false)
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales')  
        }
    }

    const paginarRegistros = (iIni, iFin) => {
        setRegistrosAmostrar(datos.slice(iIni, iFin + 1));
        paginar(iIni, iFin);
    };

    const ejecutarReporte = ()=>{
        setReporteEnEjecucion(true)
    }

    const finalizarReporte = ()=>{
        setReporteEnEjecucion(false)
    }

    const crearSubtitulosSegunParametros = ()=>{
        let descripcion = '';

        switch(parametros.criterio){
            case 'tanda':
                descripcion = `${descripcion} Tanda: ${tandas.filter(item=>item.id_tanda==parametros.id_tanda).map(item=>item.nombre)}`; break
            case 'añofiscal':
                descripcion = `${descripcion} Año fiscal: ${periodosFiscales.filter(item=>item.id_año_fiscal==parametros.id_año_fiscal).map(item=>item.nombre)}`; break
            case 'mesaño':
//                descripcion = `${descripcion} ${document.getElementById('select-mesaño').options[document.getElementById('select-mesaño').selectedIndex].text}`; break
                descripcion = `${descripcion} Mes y año: ${document.getElementById('select-mesaño').value}`; break
            case 'año':
                descripcion = `${descripcion} Año: ${document.getElementById('select-año').value}`; break
            case 'periodo':
                descripcion = `${descripcion} Período: ${document.getElementById('select-periodo-fdesde').value} -->  ${document.getElementById('select-periodo-fhasta').value}`; break
            case 'fecha':
                descripcion = `${descripcion} Fecha: ${document.getElementById('select-fecha').value}`; break
        }

        if (parametros.tipo=='cronologico'){
            //dos formas de recuperar el texto de un select, usando el vector y filter o usando el id y accediendo al DOM
            descripcion = `${descripcion} Moneda: ${monedas.filter(item=>item.id_tipo_moneda==parametros.moneda).map(item=>item.nombre)}`; 
//            descripcion = `${descripcion} Moneda: ${document.getElementById('select-moneda').options[document.getElementById('select-moneda').selectedIndex].text}`
        
            if (parametros.destino){
                descripcion = `${descripcion} Proveedor: ${parametros.destino=='pastor' ? 'Pr. ' : parametros.destino=='iglesia' ? 'Igl.' : ' '} ${parametros.nombre_destino}`
            }

            if (parametros.caja){
                descripcion = `${descripcion} Caja: ${document.getElementById('select-caja').options[document.getElementById('select-caja').selectedIndex].text}`
            }

            if (parametros.fondo){
                descripcion = `${descripcion} Fondo: ${document.getElementById('select-fondo').options[document.getElementById('select-fondo').selectedIndex].text}`
            }

            if (parametros.rubro){
                descripcion = `${descripcion} Rubro: ${document.getElementById('select-rubro').options[document.getElementById('select-rubro').selectedIndex].text}`
            }

            if (parametros.formapago){
                descripcion = `${descripcion} Forma de pago: ${document.getElementById('select-fpago').options[document.getElementById('select-fpago').selectedIndex].text}`
            }

        }
        return descripcion
    }

    const cb_filtro = item=>
    formatearComparacion(item.codigo_rubro).includes(formatearComparacion(textoBusqueda)) ||
    formatearComparacion(item.rubro).includes(formatearComparacion(textoBusqueda))


    if (huboError){
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <p>Se produjo un error al cargar los datos para esta vista</p>
            </div>
        </Main>
    }

    if (cargandoRegistros){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando registros...</span>
                    </div>
                </Main>
    };

    return (  
    <Main center>  
        {!reporteEnEjecucion && <div className={'mr-6 ml-6'}>
            <div className="flex f-col text-large justify-center items-center mb-4">
                <Typography variant="h4">
                    Reporte de Egresos
                </Typography>
            </div>
            <Parametros parametros = {parametros} 
                        setParametros={setParametros} 
                        tandas={tandas} 
                        periodosFiscales ={periodosFiscales} 
                        centrado={contadorConsulta==0 ? true : false}
                        cajas = {cajas}
                        rubros = {rubros}
                        monedas = {monedas}
                        fondos = {fondos}
                        formasPago = {formasPago}
                        ejecutarReporte = {ejecutarReporte}/>
        </div>}
        {/*El reporte se renderiza en una tabla usando los objetos titulos y columnas 
           Pero si hiciera falta hacemos el body de la tabla aquí y lo pasamos en bodyTablaCustomizado
           Esta funcionalidad se implementa de esta manera porque puede haber N reportes
           con diferentes necesidades respecto de como debe renderizarse.
           Depende del caso, a veces con definir titulos y columnas es suficiente
        */}
        {reporteEnEjecucion && <ReportesEgresosIntegrados 
                                descripcion = {subtitulo.current}
                                parametros={parametros} 
                                finalizarReporte={finalizarReporte}
                                bodyTablaCustomizado = {parametros.tipo=='cronologico' ? bodyTablaEgresosCronologicos(objetosSegunParametros(parametros,'clasesbody')) : null}
                                api={objetosSegunParametros(parametros,'api')}
                                titulo={objetosSegunParametros(parametros,'titulo')}
                                titulos={objetosSegunParametros(parametros,'titulos')}
                                columnas={objetosSegunParametros(parametros,'columnas')}
                                filtro = {objetosSegunParametros(parametros,'filtro')}
                                excel = {objetosSegunParametros(parametros,'excel')}
                                callbackCSV = {objetosSegunParametros(parametros,'csv')}
                                callbackPDF = {objetosSegunParametros(parametros,'pdf')}
                                arrayPDF = {objetosSegunParametros(parametros,'arraypdf')}
                                orientacionPDF = {objetosSegunParametros(parametros,'orientacion')}
                                subtitulo = {objetosSegunParametros(parametros,'subtitulo')}
                                clasesbody = {objetosSegunParametros(parametros,'clasesbody')}
                                claseshead = {objetosSegunParametros(parametros,'claseshead')}
                                mostrarResumenLateral 
                    />}
    </Main>
    )
}
function Parametros({parametros,
                    setParametros,
                    cajas,
                    tandas,
                    periodosFiscales,
                    centrado,
                    rubros,
                    monedas,
                    fondos,
                    formasPago,ejecutarReporte,setNombreCriterio}){

    const inputBusquedaRef = useRef()
    const nombreCriterio = useRef('Seleccione la tanda:')
    const r2 = useRef('null')

    const [buscarDestino,setBuscarDestino] = useState(false)
    const { esCelular} = useContextoGlobal();

    const handleCheckCriterio = (e)=>{
        const nuevoCriterio = e.target.value
        reinicializarCriterios(setParametros,parametros,nuevoCriterio,tandas,periodosFiscales,setNombreCriterio)
        cargarNombreCriterio(nuevoCriterio,nombreCriterio)
        hacerfocoEnPrimerInput(`select-${e.target.value}`)
    }

    const handleCheckTipo = (e)=>{
        setParametros({...parametros,tipo : e.target.value,criterio:'tanda'})
    }

    const handleCheckDestino = (e)=>{
        setParametros({...parametros,destino : e.target.name=="checkdestino" ? parametros.destino ? null : 'proveedor' : e.target.value})
    }

    const handleCheckCaja = (e)=>{
        setParametros({...parametros,caja : parametros.caja ? null : e.target.name=="checkcaja" ? 1 : e.target.value})
    }

    const handleCheckNoAgrupar = (e)=>{
        setParametros({...parametros,no_agrupar : parametros.no_agrupar ? null : e.target.name=="checknoagrupar" ? 1 : e.target.value})
    }

    const handleCheckFormaPago = (e)=>{
        setParametros({...parametros,formapago : parametros.formapago ? null : e.target.name=="checkformapago" ? 1 : e.target.value})
    }

    const handleCheckRubro = (e)=>{
        setParametros({...parametros,rubro : parametros.rubro ? null : e.target.name=="checkrubro" ? 1 : e.target.value})
    }

    const handleCheckTotalCaja = (e)=>{
        setParametros({...parametros,total_caja : parametros.total_caja ? false : true})
    }

    const handleCheckTotalDiario = (e)=>{
        setParametros({...parametros,total_diario : parametros.total_diario ? false : true})
    }

    const handleCheckTotalMensual = (e)=>{
        setParametros({...parametros,total_mensual : parametros.total_mensual ? false : true})
    }

    const handleCheckTotalAño = (e)=>{
        setParametros({...parametros,total_año : parametros.total_año ? false : true})
    }

    const handleCheckFondo = (e)=>{
        setParametros({...parametros,fondo : parametros.fondo ? null : e.target.name=="checkfondo" ? 1 : e.target.value})
    }

    const handleChangeNombre = (e)=>{
        setParametros({...parametros,nombre_destino : e.target.value})
    }

    const finalizarSeleccionObrero = (item)=>{
        setParametros({...parametros,id_obrero : item.id_obrero,nombre_destino:item.nom_simple,id_proveedor:null,id_iglesia:null})
        setBuscarDestino(false)
    }

    const finalizarSeleccionProveedor = (item)=>{
        setParametros({...parametros,id_proveedor : item.id_proveedor,nombre_destino:item.nombre,id_obrero:null,id_iglesia:null})
        setBuscarDestino(false)
    }

    const finalizarSeleccionIglesia = (item)=>{
        setParametros({...parametros,id_iglesia : item.id_iglesia,nombre_destino:item.nombre,id_proveedor:null,id_obrero:null})
        setBuscarDestino(false)
    }

    const validarParametros = ()=>{
        if (parametros.destino=="proveedor" && !parametros.id_proveedor){
            alert('Falta seleccionar un proveedor')
            inputBusquedaRef.current.focus()
            return
        }
        if (parametros.destino=="pastor" && !parametros.id_obrero){
            alert('Falta seleccionar un ministro')
            inputBusquedaRef.current.focus()
            return
        }
        if (parametros.destino=="iglesia" && !parametros.id_iglesia){
            alert('Falta seleccionar una iglesia')
            inputBusquedaRef.current.focus()
            return
        }

        if (parametros.criterio=="tanda" && !parametros.id_tanda){
            alert('Falta seleccionar una tanda')
            return
        }

        if (parametros.criterio=="añofiscal" && !parametros.id_año_fiscal){
            alert('Falta seleccionar un año fiscal')
            return
        }
        if (parametros.criterio=="año" && !parametros.año){
            alert('Falta seleccionar un año')
            return
        }
        if (parametros.criterio=="mesaño" && !parametros.mesAño){
            alert('Falta seleccionar un mes y un año')
            return
        }
        if (parametros.criterio=="periodo" && (!parametros.fechaHasta || !parametros.fechaDesde)){
            alert('Falta seleccionar un mes y un año')
            return
        }
        if (parametros.criterio=="fecha" && !parametros.fecha){
            alert('Falta seleccionar un mes y un año')
            return
        }
        ejecutarReporte()
    }

    const rubrosOrdenados = useMemo(
    () => [...rubros].sort((a, b) => (a?.nombre || '').localeCompare(b?.nombre || '', 'es', { sensitivity: 'base' })),
    [rubros]
    );
    
    return <Card className="mt-4 w-full p-10 mb-10">
                <div className="flex f-col">
                    {/*<Prueba ref2={r2}/>
                    <button onClick ={()=>alert(r2.current.options[r2.current.selectedIndex].text)}>macho</button>*/}

                    <Card className="w-full px-6 py-3 mb-3 shadow-md">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                            {/* Primera columna */}
                            <div className="flex items-center gap-2 w-full egreso-new">
                                <div className='w-[220px]'>
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Intervalo de Tiempo:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                        <select
                                            label="Seleccionar Intervalo"
                                            value={parametros.criterio}
                                            className='select-bg-ui'
                                            onChange={(val) =>  handleCheckCriterio(val)}
                                        >
                                            <option value="tanda">Tanda</option>
                                            <option value="añofiscal">Año fiscal</option>
                                            <option value="mesaño">Mes/año</option>
                                            <option value="año">Año</option>
                                            {parametros.tipo=="cronologico" && <option value="periodo">Periodo</option>}
                                            {parametros.tipo=="cronologico" && <option value="fecha">Fecha</option>}
                                        </select>                                       
                                    </div>   
                                </div>
                            </div>

                            <div className="flex flex-col w-full">
                                <div className="relative mt-2 w-full">
                                {parametros.criterio=="tanda" && <div className="flex f-row w-full ">
                                        <Seleccionador id="select-tanda" vector={tandas} valor={parametros.id_tanda} nombre="Todas" onchange={(e)=>setParametros({...parametros,id_tanda:e.target.value})} claves={{id:'id_tanda',nombre:'nombre'}}/>
                                    </div>}

                                    {parametros.criterio=="añofiscal" && <div className="flex f-row w-full">
                                        <Seleccionador id="select-añofiscal" vector={periodosFiscales} valor={parametros.id_año_fiscal} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_año_fiscal:e.target.value})} claves={{id:'id_año_fiscal',nombre:'nombre'}}/>
                                    </div>}     

                                    {parametros.criterio=="mesaño" && <div className="flex f-row w-full">
                                                {<DatePicker selected={parametros.mesAño} 
                                                    onChange={date => setParametros({...parametros,mesAño:date})} 
                                                    locale="es"
                                                    dateFormat="MM/yyyy"
                                                    id="select-mesaño"
                                                    className="select-bg-ui !h-9"
                                                    showMonthYearPicker
                                                    showFullMonthYearPicker
                                                    showFourColumnMonthYearPicker
                                                />}
                                    </div>}

                                    {parametros.criterio=="año" && <div className="flex f-row w-full">
                                                {<DatePicker selected={parametros.año} 
                                                    onChange={date => setParametros({...parametros,año:date})} 
                                                    locale="es"
                                                    id="select-año"
                                                    className="select-bg-ui !h-9"
                                                    showYearPicker
                                                    dateFormat="yyyy"
                                                />}
                                    </div>}

                                    {parametros.criterio=="periodo" && <div className="flex f-row w-full">
                                            <div className="flex f-row">
                                                        <div className="flex f-col">
                                                            <span className="text-xsmall">Desde</span>
                                                            <DatePicker selected={parametros.fechaDesde} 
                                                                onChange={date => setParametros({...parametros,fechaDesde:date})} 
                                                                locale="es"
                                                                dateFormat="MM/yyyy"
                                                                id="select-periodo-fdesde"
                                                                showMonthYearPicker
                                                                className="select-bg-ui !h-9"
                                                                showFullMonthYearPicker
                                                                showFourColumnMonthYearPicker/>
                                                        </div>
                                                        <div className="flex f-col ml-2 w-full">
                                                            <span className="text-xsmall">Hasta</span>
                                                            <DatePicker selected={parametros.fechaHasta} 
                                                                onChange={date => setParametros({...parametros,fechaHasta:date})} 
                                                                locale="es"
                                                                dateFormat="MM/yyyy"
                                                                id="select-periodo-fhasta"
                                                                className="select-bg-ui !h-9"
                                                                showMonthYearPicker
                                                                showFullMonthYearPicker
                                                                showFourColumnMonthYearPicker/>
                                                        </div>
                                            </div>
                                    </div>}

                                    {parametros.criterio=="fecha" && <div className="flex f-row w-full">
                                            <div className="flex f-row egreso-list w-full">
                                                    <DatePicker selected={parametros.fecha} 
                                                        id="select-fecha"
                                                        className="select-bg-ui !h-9 w-full"
                                                        onChange={date => setParametros({...parametros,fecha:date})} 
                                                        locale="es"/>
                                            </div>
                                    </div>}
                                </div>
                            </div>

                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Forma de Pago:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                        <Seleccionador  id='select-fpago' vector={formasPago} valor={parametros.formapago} nombre="Todos" onchange={(e)=>setParametros({...parametros,formapago:e.target.value})} claves={{id:'id_forma_pago',nombre:'nombre'}}/>
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </Card>

                    <Card className="w-full px-6 py-3 mb-3 shadow-md">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                            {/* Primera columna */}
                            <div className="flex items-center gap-2 egreso-new">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1">
                                        Pagado a:
                                    </Typography>
                                </div>
                                <div className="select-ui-data mt-3 w-full">
                                    <Select
                                        label="Seleccionar Destino"
                                        value={parametros.destino}
                                        className='select-bg-ui w-[95%]'
                                        onChange={(val) => setParametros({...parametros, destino : val})}
                                    >
                                        <Option value="proveedor">Proveedor</Option>
                                        <Option value="iglesia">Iglesia</Option>
                                        <Option value="pastor">Pastor</Option>
                                    </Select>
                                </div>
                            </div>

                            <div className="flex flex-col">
                                <div className="relative col-span-2 ... mt-3">
                                    <Input
                                        name="asunto"
                                        onInput={()=>setBuscarDestino(true)} 
                                        id="destino-n" onClick={()=>seleccionarTextoInput("destino-n")} 
                                        type="text" value={parametros.nombre_destino} 
                                        onChange={handleChangeNombre} ref={inputBusquedaRef} 
                                        placeholder={parametros.destino == 'pastor' ? 'Buscar un ministro' : parametros.destino=='proveedor' ? 'Buscar un proveedor' : 'Buscar una iglesia'}
                                        className="input-ui-data w-full"
                                        labelProps={{
                                            className: "before:content-none after:content-none",
                                        }}
                                    />
                                    { parametros.id_pastor && 
                                        <button>
                                            <FontAwesomeIcon className="ic-abm"
                                                            icon={faWindowClose} 
                                                            onClick={()=>console.log('pastor')}/>
                                        </button>}  
                                        {buscarDestino && parametros.destino=='pastor' && parametros.nombre_destino.length > 2 && 
                                            <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                                <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionObrero} origen="obreros"/>
                                            </div>
                                        }
                                        {buscarDestino && parametros.destino=='proveedor' && parametros.nombre_destino.length > 2 && 
                                            <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                                <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionProveedor} origen="proveedores"/>
                                            </div>
                                        }
                                        {buscarDestino && parametros.destino=='iglesia' && parametros.nombre_destino.length > 2 && 
                                            <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                                <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionIglesia} origen="iglesias"/>
                                            </div>
                                        }
                                </div>
                            </div>
                        </div>
                    </Card>

                    <Card className="w-full px-6 py-3 mb-3 shadow-md">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                            {/* Primera columna */}
                            <div className="flex items-center gap-2 w-full egreso-new">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Cuenta:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[99%]">
                                        <Seleccionador  id='select-rubro' vector={rubrosOrdenados} valor={parametros.rubro} nombre="Todos" onchange={(e)=>setParametros({...parametros,rubro:e.target.value})} claves={{id:'id_rubro',nombre:'nombre'}}/>
                                    </div>   
                                </div>
                            </div>
    
                            {/* Segunda columna */}
                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1">
                                        Caja:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                        <Seleccionador id='select-caja' vector={cajas} valor={parametros.caja} nombre="Todos" onchange={(e)=>setParametros({...parametros,caja:e.target.value})} claves={{id:'id_caja',nombre:'nombre'}}/>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1">
                                        Fondo de Tesorería:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[99%]">
                                        <Seleccionador  id='select-fondo' vector={fondos} valor={parametros.fondo} nombre="Todos" onchange={(e)=>setParametros({...parametros,fondo:e.target.value})} claves={{id:'id_fondo_tesoreria',nombre:'nombre'}}/>
                                    </div>
                                </div>  
                            </div>
                                        
                            {/* Tercera columna */}
                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Moneda:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                        <Seleccionador id='select-moneda' vector={monedas} valor={parametros.moneda} nombre="Todos" onchange={(e)=>setParametros({...parametros,moneda:e.target.value})} claves={{id:'id_tipo_moneda',nombre:'nombre'}}/>
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </Card>

                    <Card className="w-full px-6 py-3 mb-3 shadow-md">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                            {/* Primera columna */}
                            <div className="flex items-center gap-2 w-full egreso-new">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Totales:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                        <Checkbox
                                            label="Totales por caja"
                                            ripple={false}
                                            name="checkcaja" 
                                            checked={parametros.total_caja}
                                            onClick={handleCheckTotalCaja}
                                            className='w-5 h-5'
                                        />
                                        <Checkbox
                                            label="Totales diarios"
                                            ripple={false}
                                            name="checkcaja" 
                                            checked={parametros.total_diario}
                                            onClick={handleCheckTotalDiario}
                                            className='w-5 h-5'
                                        />
                                        <Checkbox
                                            label="Totales mensuales"
                                            ripple={false}
                                            name="checkcaja" 
                                            checked={parametros.total_mensual}
                                            onClick={handleCheckTotalMensual}
                                            className='w-5 h-5'
                                        />
                                        <Checkbox
                                            label="Totales por año"
                                            ripple={false}
                                            name="checkcaja" 
                                            checked={parametros.total_año}
                                            onClick={handleCheckTotalAño}
                                            className='w-5 h-5'
                                        />
                                    
                                    </div>   
                                </div>
                            </div>
                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Reporte:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                        <Checkbox
                                            label="Resumen"
                                            ripple={false}
                                            checked={parametros.tipo=='resumen'} 
                                            id="tipo-resumen" 
                                            name = "tipo" 
                                            value="resumen" 
                                            onClick={handleCheckTipo}
                                            className='w-5 h-5'
                                        />
                                        <Checkbox
                                            label="Cronológico"
                                            ripple={false}
                                            checked={parametros.tipo=='cronologico'} 
                                            id = "tipo-crono" 
                                            name="tipo" 
                                            value="cronologico" 
                                            onClick={handleCheckTipo}
                                            className='w-5 h-5'
                                        />
                                    
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </Card>

                    {parametros.tipo=='resumen' && <div className={`${esCelular ? '' : 'grid grid-cols-3 justify-left mt-4'}`}>
                            <Typography variant="h5" color="blue-gray" className="mt-1">
                                Totales:
                            </Typography>
                            <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Reporte sin agrupar en meses"
                                ripple={false}
                                name="checknoagrupar" 
                                checked={parametros.no_agrupar}
                                onClick={handleCheckNoAgrupar}
                                className='w-5 h-5'
                                />
                            </div>           
                        </div>
                    }

                    <div className='flex justify-center'>
                        <Button variant="gradient" className="mt-4 w-48" onClick={validarParametros}>
                            Ejecutar
                        </Button>
                    </div>
            </div>
        </Card>
}

function Seleccionador({
    valor, 
    name, 
    onchange, 
    id, 
    noDefault, 
    nombre, 
    vector, 
    claves, 
    limpiar,
    classancho
  }){
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";
    let clasesActivo = "block appearance-none w-full select-titulo rounded shadow leading-tight";

    if (classancho){
        clasesSelect=`block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }

    //recordar que un objeto puedo leerlo de 2 formas como vector o como objeto
    // es lo mismo usuario['nombre'] que usuario.nombre
    // aprovecho esta característica para hacer un seleccionador genérico y le paso
    // el nombre de la clave y el texto como un string para referenciarlo en notación vector
    return (            
        <div className="flex flex-col sel select-ui-data w-full">
            <select value={valor} name={name? name : ''} className='h-9' onChange ={onchange} id={id? id : null}>
                { noDefault ? null : <option value="*" key="1">{nombre}</option>}
                {vector.map(item=>
                        <option value={item[claves.id]} key={item[claves.id]}>
                            {item[claves.nombre]}
                        </option> 
                    )}
            </select>
            { valor!="*" && limpiar && 
                        <button>
                            <FontAwesomeIcon className="ic-abm"
                                            icon={faWindowClose} 
                                            onClick={limpiar}/>
                        </button>}  
        </div>
        )
        
}   

function determinarClases(reporteEnEjecucion){
    return reporteEnEjecucion ? "items-center justify-center ml-auto mr-auto" : "flex f-col items-center justify-center ml-auto mr-auto"
}

function objetosSegunParametros(parametros,objeto){

    if (parametros.tipo=='cronologico'){
        switch(objeto){
            case 'api': return `api/reportes/reporteegresos/${masParametros(parametros)}`
            case 'titulo': return 'Reporte de egresos'
            case 'titulos': return {col1:'Fecha',col2:'Proveedor',col3:'Comprobante',col4:'Descripcion',col5:'Monto'}
            case 'columnas' : return {col1:'Manejo las columnas en la funcion bodyTablaEgresosCronologicos'}
            case 'filtro' : return {campo1:'proveedor',campo2:'descripcion', campo3:'rubro', campo4:'caja',campo5:'fondo',campo6:'datos_bcrios',campo7:'monto_numerico'}
            case 'csv' : return item=>{return {fecha:transformarIso8601(item.fecha),proveedor:item.proveedor,tipo_comp:item.tipo_compr,nro_comprobante:item.nro_compr,descripcion:item.descripcion,monto:item.monto,caja:item.caja,rubro:item.rubro,fondo:item.fondo,datos_bancarios:item.datos_bcrios,tanda:item.tanda_desc}}
            case 'pdf' : return item => { return { 
                fecha: transformarIso8601(item.fecha), 
                proveedor: item.proveedor, 
                comprobante: `${item.tipo_compr}/${item.nro_compr}`, 
                descripcion: item.descripcion, 
                monto: item.monto, 
                caja: item.caja, 
                rubro: item.rubro,
                fondo:item.fondo,
                tanda:item.tanda_desc,
                datos_bancarios: item.datos_bcrios}
            }
            case 'excel' : return [{label:'Fecha', value:'fecha', format: val=>transformarIso8601(val)},
                        {label:'Proveedor',value:'proveedor'},
                        {label:'Rubro',value:'rubro'},
                        {label:'Caja',value:'caja'},
                        {label:'Descripción',value:'descripcion'},
                        {label:'Datos bancarios',value:'datos_bcrios'},
                        {label:'Fondo',value:'fondo'},
                        {label:'TC',value:'tipo_compr'},
                        {label:'Comprobante',value:'nro_compr'},
                        {label:'Monto',value:'monto'},{label:'Monto plano',value:'monto_numerico'}]
            case 'arraypdf' : return [{ text: 'Fecha', style: 'tableHeader' }, 
            { text: 'Proveedor', style: 'tableHeader' }, 
            { text: 'Comprobante', style: 'tableHeader' }, 
            { text: 'Descripción', style: 'tableHeader' }, 
            { text: 'Monto', style: 'tableHeader' }, 
            { text: 'Caja', style: 'tableHeader' }, 
            { text: 'Rubro', style: 'tableHeader' },
            { text: 'Fondo', style: 'tableHeader' },
            { text: 'Tanda', style: 'tableHeader' },
            { text: 'Info Banco', style: 'tableHeader' }]
            case 'orientacion' : return 'landscape'
            case 'subtitulo' : return 'landscape'
            case 'clasesbody' : return {col1:'filas-lista-ec ti-reporte-xl',col2:'filas-lista-ec ti-reporte-xxl',col3:'filas-lista-ec ti-reporte-xl',col4:'filas-lista-ec ti-reporte-xxl',col5:'filas-lista-ec ti-reporte-xl text-right'}
            case 'claseshead' : return {col1:'filas-lista-em ti-reporte-xl',col2:'filas-lista-em ti-reporte-xxl',col3:'filas-lista-em ti-reporte-xl',col4:'filas-lista-em ti-reporte-xxl text-center',col5:'filas-lista-em ti-reporte-xl text-right'}
        }
    }else{
        switch(objeto){
            case 'api': return `api/reportes/resumenegresos/${masParametros(parametros)}`
            case 'titulo': return 'Resumen de egresos'
            case 'titulos': return {col1:'Rubro',col2:'Código',col3:'Mes',col4:'Año',col5:'Monto'}
            case 'columnas' : return {col1:'rubro',col2:'codigo_rubro',col3:'mes_largo',col4:'año',col5:'egreso'}
            case 'filtro' : return {campo1:'rubro',campo2:'codigo_rubro',campo3:'egreso_numerico'}
            case 'csv' : return item=>{return {rubro:item.rubro,codigo_rubro:item.codigo_rubro,egreso:item.egreso,periodo:`${item.mes_largo} ${item.año}`}}
            case 'pdf' : return item => { return { 
                rubro: item.rubro, 
                codigo_rubro: item.codigo_rubro, 
                año: item.año,
                mes:item.mes,
                periodo: `${item.mes_largo} ${item.año}`, 
                egreso: item.egreso}
            }
            case 'excel' : return [{label:'Rubro',value:'rubro'},{label:'Código',value:'codigo_rubro'},{label:'Egreso',value:'egreso'},{label:'Mes',value:'mes_largo'},{label:'Año',value:'año'}]
            case 'arraypdf' : return [{ text: 'Rubro', style: 'tableHeader' }, 
            { text: 'Cod. Rubro', style: 'tableHeader' }, 
            { text: 'Período', style: 'tableHeader' }, 
            { text: 'Egreso', style: 'tableHeader' }]
            case 'orientacion' : return 'portrait'
            case 'clasesbody' : return {col1:'',col2:'',col3:'',col4:'',col5:'text-right'}
            case 'claseshead' : return {col1:'',col2:'',col3:'',col4:'',col5:'text-right'}
        }
    }
}


function bodyTablaEgresosCronologicos (clasesbody){
    return item => {
        return (
                <tr  className="border-bottom-solid" key={uuidv4()}>
                    <td>
                                {transformarIso8601(item.fecha)} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                                <p title='Caja' className='text-small text-white bg-tomato'>{item.caja}</p>
                                <p title='Rubro' className='text-small'>{item.rubro}</p>
                                <p title='Fondo' className='text-small text-grey-dark'>{item.fondo}</p>
                    </td>
                    <td>
                        {item.proveedor} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td>
                        {item.tipo_compr}-{item.nro_compr} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td>
                         {item.descripcion} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td className='text-right'>
                         {item.monto} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>                    
                </tr>
            )
        }
}

function bodyTablaEgresosCronologicosold (clasesbody){
    return item => {
        return (
            <tbody key={uuidv4()}>
                <tr  className="border-bottom-solid">
                    <td>
                        <span className={clasesbody.col1}>
                                {transformarIso8601(item.fecha)} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                        </span>         
                        <span className={clasesbody.col2}>{item.proveedor}</span>
                        <span className={clasesbody.col3}>{item.tipo_compr}-{item.nro_compr}</span>
                        <span className={clasesbody.col4}>{item.descripcion}</span>
                        <span className={clasesbody.col5}>{item.monto}</span>
                    </td>
                </tr>
            </tbody>
            )
        }
}

function masParametros(parametros){

    if (parametros.tipo=='cronologico'){
        switch(parametros.criterio){
            case 'tanda': return `*/*/*/*/${parametros.id_tanda}/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'añofiscal': return `*/*/*/${parametros.id_año_fiscal}/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'año': return `*/*/${parametros.año.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'mesaño': return `*/${parametros.mesAño.getMonth()+1}/${parametros.mesAño.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'periodo': return `*/*/*/*/*/${convertirMesAñoAfechaDesde(parametros.fechaDesde)}/${convertirMesAñoAfechaHasta(parametros.fechaHasta)}/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'fecha': return `${parametros.mesAño.getDate()}/${parametros.mesAño.getMonth()+1}/${parametros.mesAño.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
        }
    }else{
        switch(parametros.criterio){
            case 'tanda': return `*/*/*/${parametros.id_tanda}`
            case 'añofiscal': return `*/*/${parametros.id_año_fiscal}/*`
            case 'año': return `*/${parametros.año.getFullYear()}/*/*`
            case 'mesaño': return `${parametros.mesAño.getMonth()+1}/${parametros.mesAño.getFullYear()}/*/*`
        }
    }
}

function noNull(valor){
    if (valor){
        return valor
    }else{
        return '*'
    }
}

function convertirMesAñoAfechaDesde(fecha){
    
    // el propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha desde es el primer día del mes y año seleccionados
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha)

    const mes = fecha_new.getMonth() + 1

   // const dia = fecha_new.getDate()

    const anio = fecha_new.getFullYear()
    

  // return `${mes < 10 ? `0${mes}` : mes}-01-${anio}`
   return `${anio}-${mes < 10 ? `0${mes}` : mes}-01`

}

function convertirMesAñoAfechaHasta(fecha){
        
    // el propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha hasta es el último día del mes y año seleccionados
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha)

    const mes = fecha_new.getMonth() + 1

    const dia = fecha_new.getDate()

    const anio = fecha_new.getFullYear()
    
   const nueva_fecha =  `${anio}-${mes < 10 ? `0${mes}` : mes}-${dia < 10 ? `0${dia}` : dia}`

    return obtenerFechaUltimoDiaMes(nueva_fecha,'YYYY-MM-DD','YYYY-MM-DD')
}

function Prueba({ref2}){
    const reff = useRef('')

    return <><select title={`dd ${reff.current.value}`} ref={ref2} name="" id="">
        <option value="55">asdfasdf</option>
        <option value="78">gggg</option>
    </select>
    </>
}

function Impresiones({datos,callbackCSV,titulo,callbackPDF,arrayPDF,orientacionPDF,descripcion,parametros}){

    const [iniciarImprimirPDF,setIniciarImprimirPDF] = useState(false)

    const datosCSV = datos.map(callbackCSV)
    
    const cerrarImpresionPDF = ()=>{
        setIniciarImprimirPDF(false)
    }

    const iniciarImpresionPDF = ()=>{
        if (iniciarImprimirPDF){
            setIniciarImprimirPDF(false)
        }else{
            setIniciarImprimirPDF(true)
        }
    }

    return <div className="flex f-col">
            {datos.length > 0 && <div className="centro-w100pc">
                <span onClick={iniciarImpresionPDF} className="cursor-pointer botonNc ml-6" >
                        <FontAwesomeIcon onClick={iniciarImpresionPDF} className="color-tomato" icon={faFilePdf}/> Archivo PDF
                </span> 
                <div className="relative w-100 pdfcontainer inline">
                    {iniciarImprimirPDF && <ImpresionPDF registrosAmostrar ={datos} cerrar={cerrarImpresionPDF} impresion={imprimirEcronologicos} callbackPDF={callbackPDF} arrayPDF={arrayPDF} orientacion={orientacionPDF} tituloDefault={descripcion} parametros={parametros}/>}
                </div>
                {/*<CSVLink
                        data={datosCSV}
                        filename={`${titulo}.csv`}
                        target="_blank"
                        className="tdec-none"
                        >
                         <span className="cursor-pointer botonNc ml-6 text-black tdec-none">
                            <FontAwesomeIcon className="color-tomato" icon={faFileDownload}/> Archivo CSV 
                        </span>
                </CSVLink>*/}
                <Excel datos={datos} descripcion={descripcion}/>
            </div>}
    </div>
}

function Excel({datos,descripcion}){

    const copia = [agregarFila(datos,descripcion),...datos]
    
   return '' /*<ExcelFile filename={`Egresos cronológicos`} element={
        <span className="cursor-pointer botonNc ml-6" >
            <FontAwesomeIcon className="color-tomato" icon={faFileExcel}/> Exportar a Excel
        </span> 
    }>
        <ExcelSheet data={copia} name="Egresos">
            <ExcelColumn label="Proveedor" value="proveedor"/>
            <ExcelColumn label="Monto" value="monto_numerico"/>
            <ExcelColumn label="Rubro" value="rubro"/>
            <ExcelColumn label="Caja" value="caja"/>
            <ExcelColumn label="Rubro" value="rubro"/>
            <ExcelColumn label="Descripción" value="descripcion"/>
            <ExcelColumn label="Datos bancarios" value="datos_bcrios"/>
            <ExcelColumn label="Fondo" value="fondo"/>
            <ExcelColumn label="TC" value="tipo_compr"/>
            <ExcelColumn label="Comprobante" value="nro_compr"/>
        </ExcelSheet>
</ExcelFile>*/
}

function agregarFila(datos,descripcion){
    return {...datos[0],
            proveedor:descripcion,
            monto_numerico:null,
            rubro:null,
            caja:null,
            rubro:null,
            descripcion:null,
            datos_bcrios:null,
            fondo:null,
            tipo_compr:null,
            nro_compr:null}
}

const reinicializarCriterios = (setParametros,parametros,nuevoCriterio,tandas,periodosFiscales)=>{


    setParametros({...parametros,
                      criterio : nuevoCriterio,
                      id_tanda:tandas[0].id_tanda,
                      id_año_fiscal:periodosFiscales[0].id_año_fiscal,
                      fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
                      fechaHasta:new Date(),
                      fecha:new Date(),
                      mesAño:new Date(),
                      año:new Date(),
                    })
}

const cargarNombreCriterio = (nuevoCriterio,nombreCriterio)=>{

    switch(nuevoCriterio){
        case 'tanda' : nombreCriterio.current = 'Seleccione la tanda:';return
        case 'añofiscal' : nombreCriterio.current = 'Seleccione el año fiscal:';return
        case 'mesaño' : nombreCriterio.current = 'Seleccione el mes y año:';return
        case 'periodo' : nombreCriterio.current = 'Seleccione el período:' ;return
        case 'año' : nombreCriterio.current = 'Seleccione el año:';return
        case 'fecha' : nombreCriterio.current = 'Seleccione la fecha:';return
    }
}